var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.breadList.length)?_c('div',{staticClass:"bread"},[_c('a-breadcrumb',_vm._l((_vm.breadList),function(item){return _c('a-breadcrumb-item',{key:item.path},[_c('router-link',{attrs:{"to":item.path,"custom":""}},[_vm._v(" "+_vm._s(item.name)+" ")])],1)}),1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }